<template>
  <el-table-column
    prop="sum"
    label="Mennyiség"
    width="170"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.sum }} {{ scope.row.pack_type_name == 'egyesével' ? 'db' : scope.row.pack_type_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'sum',
  };
</script>
